import React, { FunctionComponent, ReactNode } from "react";
import { Card } from "@cmsgov/ds-medicare-gov";
import classNames from "classnames";

interface BasePlanCardProps {
  header: string | JSX.Element;
  subHeader?: string;
  planHeader?: ReactNode;
  planId?: string;
  extraInfo?: ReactNode;
  footer?: ReactNode;
  dataTestId?: string;
  baseClassName?: string;
  additionalClassNames?: string;
}

const BasePlanCard: FunctionComponent<BasePlanCardProps> = ({
  header,
  subHeader,
  planId,
  planHeader,
  extraInfo,
  footer,
  dataTestId,
  baseClassName = "mct-c-summary-page-plan-card",
  additionalClassNames = "",
}) => {
  return (
    <Card
      className={classNames(
        "ds-u-padding--3",
        baseClassName,
        additionalClassNames
      )}
    >
      <div className={`${baseClassName}__body`} data-testid={dataTestId}>
        <h3 className={`ds-text-heading--lg ${baseClassName}__header`}>
          {header}
        </h3>
        {subHeader && (
          <p className={`${baseClassName}__sub-header`}>{subHeader}</p>
        )}
        {planHeader && planHeader}
        {planId && <p className={`${baseClassName}__id`}>({planId})</p>}
        {extraInfo && extraInfo}
      </div>
      {footer && (
        <div className={`${baseClassName}__footer mct-hide-print`}>
          {footer}
        </div>
      )}
    </Card>
  );
};

export default BasePlanCard;
